import * as React from "react";
import { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { AnyForNow } from "./types";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Collapse,
  Tabs,
  Tab,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import { PageDataContext } from "../../utils/common/PageDataContext";
import GrnSupplierDetails from "../../components/grn/GrnSupplierDetails";
import GrnDetails from "../../components/grn/GrnDetails";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import { advanceSearchData } from "../../components/grid/GridData";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import PreviewIcon from "@mui/icons-material/Preview";
import PurchaseOrderItemsPopUp from "../../components/grn/grnpopup/PurchaseOrderItemsPopUp";
import { useLocation } from "react-router-dom";
import GrnBillingInfo from "../../components/grn/GrnBillingInfo";
import GrnAttachments from "../../components/grn/GrnAttachments";
import GrnItemsTable from "../../components/grn/GrnItemsTable";
import { UseGrnDetails } from "../../hooks/UseGrnDetails";
import { UseGrnItemsTable } from "../../hooks/UseGrnItemsTable";
import { GRN_API_01, SUPPLIER_API_02 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import GrnSupplierSearch from "../../components/grn/GrnSupplierSearch";
import { CON_STATUS_ACTIVE, CON_YES } from "../../utils/sys/Constants";
import {
  APPROVAL_WORKFLOW,
  GRN_CONSTRAINTS,
  GRN_STATUS,
  GRN_STORAGE_KEYS,
  GRN_VIEW_DETAIL,
  GRN_VIEW_RETURN_FILTER,
  PARAM_ID,
  TAX_CODE,
} from "../../utils/sys/GrnConstants";
import {
  GRN_SUCCESS_MESSAGES,
  GRN_FAILURE_MESSAGES,
  GRN_ERROR_MESSAGES,
  GRN_CONFIRM_MESSAGES,
} from "../../utils/sys/GrnValidation";
import { GRN_ROUTES, RELATED_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  BUTTON_LABELS,
  GRN_CREATE_LABELS,
  GRN_SECTIONS,
  PAGE_TITLES,
} from "../../utils/sys/GrnLabels";
import {
  UpdateGrnBasicData,
  UpdateGrnDocsData,
  UpdateGrnProductData,
  ProcessGrnApi,
} from "../../services/GrnApi";
import SystemAlert from "../../components/common/SystemAlert";
import PopUp from "../../components/popup/PopUp";
import { calculateGrnTotals } from "../../hooks/GrnCalculate";
import TabPanel from "../../components/common/TabPanel";
import { useAlertQueue } from "../../hooks/useAlertQueue";
import { EDIT_GRN_TAB_INDEX, EDIT_GRN_UI } from "./constants";

interface EditGrnProps {
  desktopOpen?: boolean;
  initialDataGrnItemsTable?: AnyForNow;
}

const EditGrn: React.FC<EditGrnProps> = ({
  desktopOpen = true,
  initialDataGrnItemsTable = [],
}) => {
  // Get user parameters from Redux store
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const grnItemsTable = UseGrnItemsTable([], null);
  const [grncharges, setGrnCharges] = useState<AnyForNow[]>([]);
  const [addedCharges, setAddedCharges] = useState<AnyForNow[]>([]);
  const {
    grnItems,
    supplierItems,
    setSupplierItems,
    selectedSupplier,
    setSelectedSupplier,
    expanded,
    setExpanded,
    popupType,
    setPopupType,
    fileName,
    setFileName,
    documentType,
    setDocumentType,
    reasonForReje,
    setReasonForReje,
    errors,
    setErrors,
    toggleExpand,
    inputValue,
    setInputValue,
    handleAddNewItem,
    toggleRejectItems,
    toggleFocItems,
    showFocItems,
    showRejectItems,
    showItemAttachments,
    toggleItemAttachments,
    rejectItems,
    setRejectItems,
    attachments,
    setAttachments,
    handleClearRejectItems,
    handleClearAttachments,
    handleClearFocItems,
    setShowRejectItems,
    setShowFocItems,
    setShowItemAttachments,
    taxValues,
    setTaxValues,
    grnTaxTypes,
    setTotalTax,
    setGrnItems,
  } = grnItemsTable;

  const [grnList, setGrnList] = useState<AnyForNow[]>([]);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { grncode, trsts, pocode } = location.state || {};
  const [grnReturns, setGrnReturns] = useState<AnyForNow[]>([]);
  const [otherchargevalue, setotherchargevalue] = useState<AnyForNow[]>([]);
  const [payTax, setPayTax] = useState<AnyForNow[]>([]);
  const [totalGross, setTotalGross] = useState<number>(0);
  const { setPageData } = useContext(PageDataContext);
  const [supplierOptions, setSupplierOptions] = useState<AnyForNow[]>([]);
  const [tabValue, setTabValue] = useState<number>(EDIT_GRN_TAB_INDEX.SUPPLIER_DETAILS);
  const {
    alertState,
    showAlert,
    enqueueMessages,
    handleClose: handleAlertClose,
  } = useAlertQueue();
  const {
    open: alertOpen,
    type: alertType,
    message: alertMessage,
  } = alertState;
  const [confirmCancelOpen, setConfirmCancelOpen] = useState<boolean>(false);
  const [grnPaySummary, setGrnPaySummary] = useState<AnyForNow>(null);
  const rightSidebarRef = useRef<HTMLDivElement>(null);
  const grnDetailsForm = UseGrnDetails();
  const [, setIsBillingSaved] = useState<boolean>(false);
  const { validateFields, warehouse } = grnDetailsForm;
  const isEditMode = grnList.length > 0;
  const [searchBy, setSearchBy] = useState<string>(GRN_CREATE_LABELS.SEARCH_BY_SUPPLIER);
  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(false);
  const [searchInputValue, setSearchInputValue] = useState<string>("");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const processTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const processPromiseRef = useRef<Promise<any> | null>(null);
  const lastProcessedResponseRef = useRef<string | null>(null);
  const isProcessingRef = useRef<boolean>(false);
 const { origin } = location?.state || {};
  // Separate errors state for GrnDetails form (NOT for items table)
  const [grnDetailsErrors, setGrnDetailsErrors] = useState<AnyForNow>({});

  const [filteredRows] = useState<AnyForNow[]>(advanceSearchData.rows);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [processResponse, setProcessResponse] = useState<AnyForNow>(null);
  const [grnData, setGrnData] = useState<AnyForNow>({
    products: [],
    billings: [],
    taxes: [],
  });
  const isManualOperation = useRef<boolean>(false);
  const moduleParamJson = useSelector(
    (state: AnyForNow) => state.moduleParamJson
  );
  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});
  const isApprovalWorkflowEnabled =
    moduleParamJsonArray.filter((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)[0]
      ?.PARAVALUE === CON_YES;
  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.EDIT_GRN,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);

  // Use refs to store latest values to avoid recreating callback on every render
  const grnDataRef = useRef<AnyForNow>(grnData);
  const addedChargesRef = useRef<AnyForNow[]>(addedCharges);
  const payTaxRef = useRef<AnyForNow[]>(payTax);

  // Keep refs in sync with state
  useEffect(() => {
    grnDataRef.current = grnData;
  }, [grnData]);

  useEffect(() => {
    addedChargesRef.current = addedCharges;
  }, [addedCharges]);

  useEffect(() => {
    payTaxRef.current = payTax;
  }, [payTax]);

  const handleProcessGrn = useCallback(async (): Promise<any | null> => {
    // Prevent concurrent calls
    if (isProcessingRef.current || processPromiseRef.current) {
      return processPromiseRef.current;
    }

    isProcessingRef.current = true;

    console.log("====== handleProcessGrn CALLED in EditGrn ======");
    console.log("addedCharges state:", JSON.stringify(addedChargesRef.current, null, 2));
    console.log(
      "otherchargevalue state:",
      JSON.stringify(otherchargevalue, null, 2)
    );
    console.log(
      "grnData.billings:",
      JSON.stringify(grnDataRef.current?.billings, null, 2)
    );
    console.log("==============================================");

    processPromiseRef.current = new Promise((resolve, reject) => {
      ProcessGrnApi({
        USERNAME,
        COMPCODE,
        RESTCODE: warehouse || "",
        STAFFMAPLOCODE,
        grncode,
        grnData: grnDataRef.current,
        addedCharges: addedChargesRef.current,
        payTax: payTaxRef.current,
        onSuccess: (response) => {
          console.log("ProcessGrnApi SUCCESS - setting processResponse");
          
          // Create a stable hash of response to prevent re-processing same data
          const responseHash = JSON.stringify(response);
          if (lastProcessedResponseRef.current === responseHash) {
            console.log("Skipping duplicate processResponse update");
            isProcessingRef.current = false;
            processPromiseRef.current = null;
            resolve(response);
            return;
          }
          
          lastProcessedResponseRef.current = responseHash;
          setProcessResponse(response); // store response for sidebar
          isProcessingRef.current = false;
          processPromiseRef.current = null;
          resolve(response);
        },
        onError: (error) => {
          console.error(" ProcessGrnApi ERROR:", error);
          showAlert(GRN_FAILURE_MESSAGES.SAVE_FAILED, "error");
          isProcessingRef.current = false;
          processPromiseRef.current = null;
          reject(error);
        },
      });
    });

    try {
      return await processPromiseRef.current;
    } catch (error) {
      isProcessingRef.current = false;
      processPromiseRef.current = null;
      throw error;
    }
  }, [
    USERNAME,
    COMPCODE,
    warehouse,
    STAFFMAPLOCODE,
    grncode,
    showAlert,
    // Removed grnData, addedCharges, payTax - using refs instead
  ]);

  // Use ref to store handleProcessGrn to avoid recreating scheduleProcessGrn
  const handleProcessGrnRef = useRef(handleProcessGrn);
  useEffect(() => {
    handleProcessGrnRef.current = handleProcessGrn;
  }, [handleProcessGrn]);

  const scheduleProcessGrn = useCallback(() => {
    // Clear any existing timeout
    if (processTimeoutRef.current) {
      clearTimeout(processTimeoutRef.current);
      processTimeoutRef.current = null;
    }
    
    // Debounce API call - only execute after 500ms of no changes
    processTimeoutRef.current = setTimeout(() => {
      handleProcessGrnRef.current().catch((err) =>
        console.error("Scheduled ProcessGrn failed:", err)
      );
      processTimeoutRef.current = null;
    }, 500);
  }, []); // Empty deps - function is stable, uses ref for latest handleProcessGrn

  const goNextToView = (
    status: number | string,
    addedItems: AnyForNow[],
    response: AnyForNow
  ): void => {
    const validationErrors = validateFields();

    if (Object.keys(validationErrors).length > 0) {
      console.log("Validation errors:", validationErrors);
      setGrnDetailsErrors(validationErrors); // Set errors to state for UI display
      enqueueMessages(Object.values(validationErrors));
      showAlert(GRN_ERROR_MESSAGES.ALL_FIELDS_REQUIRED, "error");
      return;
    }

    // Clear errors if validation passes
    setGrnDetailsErrors({});

    if (addedItems.length === 0) {
      showAlert(GRN_ERROR_MESSAGES.NO_ITEMS, "error");
      return;
    }

    const formDataToPass = {
      invoiceNumber: grnDetailsForm.invoiceNumber,
      invoiceDate: grnDetailsForm.invoiceDate,
      warehouse: grnDetailsForm.warehouse,
      partialShipments: grnDetailsForm.partialShipments,
      deliveryDate: grnDetailsForm.deliveryDate,
      poNumber: grnDetailsForm.poNumber,
      poDate: grnDetailsForm.poDate,
      dispatchNumber: grnDetailsForm.dispatchNumber,
      dispatchDate: grnDetailsForm.dispatchDate,
      awbNumber: grnDetailsForm.awbNumber,
      billOfLandingNumber: grnDetailsForm.billOfLandingNumber,
      deliveryNoteNumber: grnDetailsForm.deliveryNoteNumber,
    };

    // Save edited data to localStorage for persistence across navigation
    const viewDataToPersist = {
      grncode,
      pocode,
      trsts: status,
      grnItems: grnItemsTable.grnItems,
      rejectItems,
      attachments: grnAttachments,
      origin: GRN_VIEW_DETAIL.ORIGIN_EDIT,
       origin_1: origin, 
      grnDetailsForm: formDataToPass,
      selectedSupplier,
      grnData,
      totalGross,
      grnTaxTypes,
      taxValues,
      totalDiscount: grnItemsTable.totalDiscount,
      grncharges: grncharges,
      addedCharges: addedCharges,
      processResponse: response,
      calSummary: processResponse,
      timestamp: Date.now(), // Add timestamp to track when data was saved
    };

    // Helper function to reduce attachment data size for localStorage
    const reduceAttachmentSize = (list: AnyForNow[] = []): AnyForNow[] =>
      list.map((att) => {
        // Keep only metadata, remove large base64 strings
        const reduced = {
          FILENAME: att?.FILENAME || att?.filename || "",
          DOCTYPECODE: att?.DOCTYPECODE || att?.doctypecode || "",
          DOCTYPE: att?.DOCTYPE || att?.doctypename || "",
          REMARK: att?.REMARK || att?.remark || "",
          doctypeothername: att?.doctypeothername || "",
          // Keep a flag to indicate if file data exists (for re-upload detection)
          hasFileData: !!(att?.docpathjson || att?.bytarr || att?.FILEPATH),
        };
        // Only include docpathjson if it's small (metadata, not base64)
        if (att?.docpathjson && att.docpathjson.length < 500) {
          (reduced as AnyForNow).docpathjson = att.docpathjson;
        }
        return reduced;
      });

    // Helper function to safely save to localStorage with size reduction
    const safeSaveToLocalStorage = (key: string, data: AnyForNow): boolean => {
      try {
        // Clear existing data first to free up space
        try {
          localStorage.removeItem(key);
        } catch (e) {
          // Ignore remove errors
        }

        // First try with full data
        let serialized = JSON.stringify(data);
        const sizeKB = serialized.length / 1024;
        console.log(`localStorage size for ${key}: ${sizeKB.toFixed(2)} KB`);

        // If data is too large (>4MB), reduce attachment sizes
        if (sizeKB > 4096) {
          console.warn(`Data too large (${sizeKB.toFixed(2)} KB), reducing attachment sizes...`);
          const reducedData = {
            ...data,
            attachments: reduceAttachmentSize(data.attachments || []),
            // Also reduce attachments in grnItems
            grnItems: (data.grnItems || []).map((item: AnyForNow) => ({
              ...item,
              itemAttachments: item.itemAttachments ? {
                ...item.itemAttachments,
                attachments: reduceAttachmentSize(item.itemAttachments.attachments || []),
              } : item.itemAttachments,
              rejectItem: item.rejectItem ? {
                ...item.rejectItem,
                attachments: reduceAttachmentSize(item.rejectItem.attachments || []),
              } : item.rejectItem,
            })),
          };
          serialized = JSON.stringify(reducedData);
          console.log(`Reduced localStorage size for ${key}: ${(serialized.length / 1024).toFixed(2)} KB`);
        }

        localStorage.setItem(key, serialized);
        return true;
      } catch (error: any) {
        // If quota exceeded, try with reduced data
        if (error?.name === 'QuotaExceededError' || error?.message?.includes('quota')) {
          console.warn(`Quota exceeded for ${key}, trying with minimal data...`);
          try {
            // Create minimal version without large data
            const minimalData = {
              grncode: data.grncode,
              pocode: data.pocode,
              trsts: data.trsts,
              origin: data.origin,
                origin_1: data.origin_1,   // NEW
              grnDetailsForm: data.grnDetailsForm,
              selectedSupplier: data.selectedSupplier,
              grnData: data.grnData,
              totalGross: data.totalGross,
              grnTaxTypes: data.grnTaxTypes,
              taxValues: data.taxValues,
              totalDiscount: data.totalDiscount,
              timestamp: data.timestamp,
              // Keep only essential item data without attachments
              grnItems: (data.grnItems || []).map((item: AnyForNow) => {
                const { itemAttachments, rejectItem, ...rest } = item;
                return rest;
              }),
            };
            const minimalSerialized = JSON.stringify(minimalData);
            localStorage.setItem(key, minimalSerialized);
            console.log(`Saved minimal data for ${key}: ${(minimalSerialized.length / 1024).toFixed(2)} KB`);
            return true;
          } catch (minimalError) {
            console.error(`Failed to save even minimal data to ${key}:`, minimalError);
            // Clear the item to prevent issues
            try {
              localStorage.removeItem(key);
            } catch (e) {
              // Ignore
            }
            return false;
          }
        }
        console.error(`Failed to save to ${key}:`, error);
        return false;
      }
    };

    // Try to save to localStorage (navigation state will work regardless)
    safeSaveToLocalStorage(GRN_STORAGE_KEYS.GRN_VIEW_DATA, viewDataToPersist);

    navigate(GRN_ROUTES.VIEW_DETAIL, {
      state: viewDataToPersist,
    });
  };

  const handleTotalGrossChange = (value: number): void => {
    setTotalGross(value);
  };
  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ): void => {
    setTabValue(newValue);
  };

  const toggleRightSidebar = useCallback((): void => {
    scheduleProcessGrn();
    setRightSidebarOpen((prev) => !prev);
  }, [scheduleProcessGrn]);

  const toggleFilter = useCallback((): void => {
    setShowFilter((prev) => !prev);
  }, []);

  const handleClickOpen = (): void => {
    setOpenDialog(true);
  };

  const handleClose = (): void => {
    setOpenDialog(false);
  };

  const openSidebarToBillingInfo = (): void => {
    setRightSidebarOpen(true);
    setTabValue(EDIT_GRN_TAB_INDEX.BILLING_INFO);
  };

  const menuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <PreviewIcon />,
      onClick: () => handleClickOpen(),
    },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (processTimeoutRef.current) {
        clearTimeout(processTimeoutRef.current);
        processTimeoutRef.current = null;
      }
    };
  }, [rightSidebarOpen]);

  const fetchGrnData = useCallback(
    async (currentGrnCode, currentTrsts) => {
      try {
        const result = await externalgetApi(GRN_API_01, "GET", {
          COMPCODE,
          GRNCODE: currentGrnCode,
          STS: currentTrsts,
        });
        setGrnList(result || []);
        setGrnReturns(result?.[0]?.returns || []);
        setotherchargevalue(result?.[0]?.charges || []);
        setPayTax(result?.[0]?.grnPayTax || []);

        if (
          result &&
          result.length > 0 &&
          result[0].grnPaySummery?.length > 0
        ) {
          setGrnPaySummary(result[0].grnPaySummery[0]);
        } else {
          setGrnPaySummary(null);
        }

        console.log("fetchGrnData", result);
      } catch (err) {
        console.error("Error fetching GRN data:", err);
        showAlert(GRN_FAILURE_MESSAGES.FETCH_GRN_FAILED, "error");
      }
    },
    [COMPCODE, showAlert]
  );

  // Restore addedCharges and grncharges from localStorage when component mounts (e.g., when navigating back from ViewDetailGrn)
  useEffect(() => {
    if (!grncode) return; // Wait for grncode to be available

    const persistedViewData = localStorage.getItem(GRN_STORAGE_KEYS.GRN_VIEW_DATA);
    if (persistedViewData) {
      try {
        const persistedData = JSON.parse(persistedViewData);
        // Check if data is recent (within last 2 hours) and matches current grncode
        const isPersistedDataRecent =
          persistedData.timestamp &&
          Date.now() - persistedData.timestamp < GRN_VIEW_DETAIL.PERSIST_WINDOW_MS;
        const matchesCurrentGrn = persistedData.grncode === grncode;

        if (isPersistedDataRecent && matchesCurrentGrn) {
          // Restore addedCharges if available
          if (
            persistedData.addedCharges &&
            Array.isArray(persistedData.addedCharges)
          ) {
            setAddedCharges(persistedData.addedCharges);
          }
          // Restore grncharges if available
          if (
            persistedData.grncharges &&
            Array.isArray(persistedData.grncharges)
          ) {
            setGrnCharges(persistedData.grncharges);
          }
        }
      } catch (err) {
        console.error("Error parsing persisted view data:", err);
      }
    }
  }, [grncode]);

  // Convert otherchargevalue (from database) → addedCharges (for ProcessGrnApi)
  // This ensures charges are available when we call ProcessGrnApi
  // Only initialize once when data is first loaded, don't overwrite manually added charges
  const chargesInitializedRef = useRef<boolean>(false);
  useEffect(() => {
    // Only initialize if we haven't initialized yet AND we have otherchargevalue from DB
    // This prevents overwriting charges that were manually added by the user
    if (chargesInitializedRef.current) {
      return; // Already initialized, don't overwrite
    }

    console.log("🔄 Converting otherchargevalue → addedCharges (initial load only)");
    console.log(
      "  otherchargevalue:",
      JSON.stringify(otherchargevalue, null, 2)
    );

    if (Array.isArray(otherchargevalue) && otherchargevalue.length > 0) {
      // Group by chargecode and sum chargevalue (similar to GrnBillingInfo)
      const groupedTotals = (otherchargevalue as any[]).reduce(
        (acc: Record<string, number>, curr: any) => {
          const code = String(curr.chargecode);
          const value = Number(curr.chargevalue) || 0;
          acc[code] = (acc[code] || 0) + value;
          return acc;
        },
        {} as Record<string, number>
      );

      // Convert grouped totals to addedCharges format
      const newAddedCharges = Object.entries(groupedTotals).map(
        ([chargecode, chargevalue]) => {
          // Find the matching charge details from grncharges (for display name)
          const matched = Array.isArray(grncharges)
            ? (grncharges as any[]).find(
                (g) => String(g.chargecode) === chargecode
              )
            : null;

          return {
            ...(matched || { chargecode }),
            chargecode,
            chaegerate: chargevalue,
            chargevalue: chargevalue,
          };
        }
      );

      console.log(
        "  ✅ Converted addedCharges:",
        JSON.stringify(newAddedCharges, null, 2)
      );
      setAddedCharges(newAddedCharges);
      chargesInitializedRef.current = true; // Mark as initialized
    } else if (otherchargevalue.length === 0 && grncharges.length > 0) {
      // If otherchargevalue is empty but grncharges is loaded, mark as initialized
      // This prevents the effect from running again when grncharges loads later
      chargesInitializedRef.current = true;
    }
  }, [otherchargevalue, grncharges]);

  useEffect(() => {
    if (grncode && trsts) {
      fetchGrnData(grncode, trsts);
    } else {
      // console.warn("Missing grncode or trsts in location.state");
      // setAlertType("error");
      // setAlertMessage("Missing GRN code or status");
      // setAlertOpen(true);
    }
  }, [fetchGrnData, grncode, trsts]);

  // REMOVED: Initial load useEffect that was causing infinite loops
  // API should only be called when user changes billing values, not on page load

  const handleAddNewSupplier = useCallback(() => {
    navigate(RELATED_ROUTES.SUPPLIER_ADD);
  }, [navigate]);

  const fetchSuppliers = useCallback(async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
        STSCODE: CON_STATUS_ACTIVE,
      };
      const suppliersResponse = await externalgetApi(
        SUPPLIER_API_02,
        "GET",
        params
      );
      const options = suppliersResponse.map((supplier) => ({
        optSupplierRefCode: supplier.suprefcode?.toString() || "",
        optSupplierId: supplier.supid || "",
        optSupplierName: supplier.suppliername || supplier.companyname || "",
        email: supplier.email || "",
        contactNo: supplier.contactno || "",
        optSupplieraddressline1: supplier.addresslinE1 || "",
        optSupplieraddressline2: supplier.addresslinE2 || "",
        optSupplieraddressline3: supplier.addresslinE3 || "",
      }));
      setSupplierOptions(options);
    } catch (error) {
      console.error("Failed to fetch suppliers:", error);
    }
  }, [COMPCODE, STAFFMAPLOCODE]);

  useEffect(() => {
    fetchSuppliers();
  }, [fetchSuppliers]);

  // Memoize grnHeaderSupplier to prevent new object creation on every render
  const grnHeaderSupplier = React.useMemo(() => {
    return grnList.length > 0 ? grnList[0].header : null;
  }, [grnList]);

  // Create stable selected supplier value for GrnSupplierSearch
  const stableSelectedSupplier = React.useMemo(() => {
    return selectedSupplier || grnHeaderSupplier;
  }, [selectedSupplier, grnHeaderSupplier]);

  // Deduplicate attachments: use documents from API as base, then add only new attachments from state
  const grnAttachments = React.useMemo(() => {
    const apiDocuments = grnList.length > 0 ? grnList[0].documents || [] : [];
    const stateAttachments = attachments || [];
    
    // Create a set of unique identifiers from API documents
    // Use grndoccode if available, otherwise use a combination of doctypecode and filename
    const apiDocumentKeys = new Set(
      apiDocuments.map((doc: AnyForNow) => {
        if (doc.grndoccode) return `grndoccode:${doc.grndoccode}`;
        const filename = doc.filename || doc.fileName || doc.FILENAME || '';
        const doctypecode = doc.doctypecode || doc.DOCTYPECODE || '';
        return `key:${doctypecode}:${filename}`;
      })
    );
    
    // Filter state attachments to only include new ones (not already in API documents)
    const newAttachments = stateAttachments.filter((att: AnyForNow) => {
      // New attachments won't have grndoccode (they're not saved yet)
      if (!att.grndoccode) {
        const filename = att.filename || att.fileName || att.FILENAME || '';
        const doctypecode = att.doctypecode || att.DOCTYPECODE || '';
        const key = `key:${doctypecode}:${filename}`;
        return !apiDocumentKeys.has(key);
      }
      // If it has grndoccode, check if it's already in API documents
      return !apiDocumentKeys.has(`grndoccode:${att.grndoccode}`);
    });
    
    // Combine: API documents first (existing), then new attachments
    return [...apiDocuments, ...newAttachments];
  }, [grnList, attachments]);

  const grndoccode =
    grnAttachments.length > 0 ? grnAttachments[0].grndoccode : null;

  const handleUpdateGrnBasic = () => {
    UpdateGrnBasicData({
      grnDetailsForm,
      selectedSupplier,
      grncode,
      pocode,
      sts: GRN_STATUS.SAVED,
      COMPCODE,
      STAFFMAPLOCODE,
      USERNAME,

      onSuccess: (response) => {
        console.log("GRN created successfully:", response);
        showAlert(GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS, "success");
      },
      onError: (error) => {
        console.error("Failed to create GRN:", error);
        showAlert(GRN_FAILURE_MESSAGES.UPDATE_FAILED, "error");
      },
    });
  };

  // Use ref to track the last supplier code we set to prevent infinite loops
  const lastSetSupplierCode = useRef<string | null>(null);

  useEffect(() => {
    if (grnList.length > 0) {
      const header = grnList[0].header;
      if (header) {
        const supplierRefCode = header.suprefcode?.toString() || "";

        // Only update if this is a different supplier than last time
        if (supplierRefCode && supplierRefCode !== lastSetSupplierCode.current) {
          const newSupplier = {
            optSupplierRefCode: supplierRefCode,
            optSupplierId: header.supid || "",
            optSupplierName: header.suppliername || header.companyname || "",
            email: header.email || "",
            contactNo: header.contactno || "",
            optSupplieraddressline1: header.addresslinE1 || "",
            optSupplieraddressline2: header.addresslinE2 || "",
            optSupplieraddressline3: header.addresslinE3 || "",
          };

          setSelectedSupplier(newSupplier);
          lastSetSupplierCode.current = supplierRefCode;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grnList]); // Removed setSelectedSupplier from dependencies - it's a stable setter function

  useEffect(() => {
    if (grnList.length > 0) {
      const products = grnList[0].products || [];
      const returns = grnList[0].returns || [];
      console.log("products", products.docpathjson);

      const itemsWithReject = products.map((product) => {
        const returnItem = returns.find(
          (ret) => ret.supproductcode === product.supproductcode
        );

        let docpathjson = [];
        if (returnItem?.docpathjson) {
          try {
            const parsed = JSON.parse(returnItem.docpathjson);
            const parsedArray = Array.isArray(parsed) ? parsed : [];
            // Filter out empty/invalid attachments - only include those with valid file data
            docpathjson = parsedArray
              .filter((att) => {
                // Only include attachments with valid file data
                const hasValidFileData =
                  (att?.FILEPATH && att.FILEPATH.trim() !== "") ||
                  (att?.fileUrl && att.fileUrl.trim() !== "") ||
                  (att?.docpathjson && att.docpathjson.trim() !== "");
                const hasFileName = att?.FILENAME || att?.filename;
                return hasValidFileData || hasFileName;
              })
              .map((att) => ({
                ...att,
                id: att.id || `${Date.now()}-${Math.random()}`,
              }));
          } catch (err) {
            console.error("Invalid JSON in docpathjson:", err);
            docpathjson = [];
          }
        }

        let docpathjsonArray = [];
        if (product?.docpathjson) {
          try {
            const parsed = JSON.parse(product.docpathjson);
            console.log("parsed docpathjson", parsed);
            docpathjsonArray = Array.isArray(parsed)
              ? parsed.map((att) => ({
                  ...att,
                  id: att.id || `${Date.now()}-${Math.random()}`,
                }))
              : [];
          } catch (err) {
            console.error("Invalid JSON in product.docpathjson:", err);
          }
        }

        return {
          ...product,
          // Ensure value column shows backend grossvalue on edit
          itemvalue: Number(product.grossvalue) || 0,
          grossvalue: Number(product.grossvalue) || 0,
          taxvalue: Number(product.taxvalue) || 0,
          isAdded: true,
          rejectItem: returnItem
            ? {
                ...returnItem,
                attachments: docpathjson, // Editable attachments for reject items
              }
            : {
                returnedqty: "",
                reason: "",
                descrip: "",
                supproductcode: 0,
                productcode: 0,
                attachments: [], // Empty attachments for reject items
              },
          itemAttachments: {
            ...product.itemAttachments,
            attachments: docpathjsonArray, // Editable attachments for item attachments
          },
        };
      });

      setGrnItems(itemsWithReject);

      setShowRejectItems({});
      setShowFocItems({});
      setShowItemAttachments({});
    }
  }, [
    grnList,
    setGrnItems,
    setShowFocItems,
    setShowItemAttachments,
    setShowRejectItems,
  ]);

  const handleUpdateProductData = () => {
    // Prevent infinite loop from useEffect auto-processing
    isManualOperation.current = true;

    const validationErrors = validateFields();

    if (Object.keys(validationErrors).length > 0) {
      console.log("Validation errors:", validationErrors);
      setGrnDetailsErrors(validationErrors); // Set errors to state for UI display
      enqueueMessages(Object.values(validationErrors));
      showAlert(GRN_ERROR_MESSAGES.ALL_FIELDS_REQUIRED, "error");
      isManualOperation.current = false;
      return;
    }

    // Clear errors if validation passes
    setGrnDetailsErrors({});

    // First run NEXT PROCESS
    UpdateGrnProductData({
      grnItems: grnItemsTable.grnItems.filter((item) => item.isAdded === true),
      attachments,
      USERNAME,
      grncode,
      grnData,
      STAFFMAPLOCODE,
      COMPCODE,
      sts: "4",
      trsts: "4",
      charges: otherchargevalue,
      addedCharges,
      payTax,

      // Pass next process result
      calSummary: processResponse,

      onSuccess: (response) => {
        console.log("GRN created successfully:", response);
        showAlert(GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS, "success");
        // Reset flag after successful save
        isManualOperation.current = false;
      },

      onError: (error) => {
        console.error("Failed to create GRN:", error);
        showAlert(GRN_FAILURE_MESSAGES.UPDATE_FAILED, "error");
        // Reset flag on error
        isManualOperation.current = false;
      },
    });
  };

  const handleCancelClick = () => {
    setConfirmCancelOpen(true);
  };

  const handleConfirmCancel = () => {
  setConfirmCancelOpen(false);

  if (origin === GRN_VIEW_RETURN_FILTER.ORIGIN_EDIT_RETURN) {
    navigate(GRN_ROUTES.VIEW_MY_ACTION_INITIATOR);
    return;
  }

  navigate(GRN_ROUTES.LIST); // Redirect on Yes
};

  const handleCancelClose = () => {
    setConfirmCancelOpen(false); // Close popup on No
  };

  const handleUpdateDocsData = () => {
    UpdateGrnDocsData({
      attachments,
      USERNAME,
      COMPCODE,
      grncode,
      grndoccode: "",
      sts: GRN_STATUS.SAVED,

      onSuccess: (response) => {
        console.log("GRN created successfully:", response);
        showAlert(GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS, "success");

        setTimeout(() => {
          window.location.reload(); // refresh the page
        }, GRN_CONSTRAINTS.NAVIGATION_TIMEOUT);
      },
      onError: (error) => {
        console.error("Failed to create GRN:", error);
        showAlert(GRN_FAILURE_MESSAGES.UPDATE_FAILED, "error");
      },
    });
  };

  // REMOVED - This useEffect was redundant with the one below (line 963-987)
  // that already maps grnItems to products AND calculates totals.
  // Having both caused cascading state updates and infinite loops.

  function updateGrnData(newProducts, newBillings) {
    const { updatedProducts, billings, taxes } = calculateGrnTotals({
      products: newProducts || grnData.products,
      billings: newBillings || grnData.billings,
    });

    setGrnData((prev) => ({
      ...prev,
      // isEditMode: true,
      products: updatedProducts,
      billings,
      taxes,
    }));
  }
  const setBillLevelDiscountPercent = (value) => {
    const updatedBillings = {
      ...grnData.billings,
      billLevelDiscountApplied: true, // ensure flag is set
      billLevelDiscountPercent: value,
      bulkDiscountPercent: value, // if both are meant to be same
    };
    updateGrnData(null, updatedBillings);
  };

  // Clear products' discountrate when bill-level discount is entered (on blur)
  const applyBillLevelDiscountToProducts = (value: number) => {
    // When bill-level discount is applied, clear item-level discount fields
    setGrnItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        discountrate: 0, // Clear the discount rate
      }))
    );
  };

  const setBillLevelTaxAmount = (value) => {
    const updatedBillings = {
      ...grnData.billings,
      billLevelTaxPercent: value,
    };
    updateGrnData(null, updatedBillings);
  };

  // Clear products' taxrate when bill-level tax is entered (on blur)
  const applyBillLevelTaxToProducts = (value: number) => {
    // When bill-level tax is applied, clear item-level tax fields
    setGrnItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        taxrate: 0, // Clear the tax rate
      }))
    );
  };

  useEffect(() => {
    if (!grnItems || grnItems.length === 0) {
      return;
    }

    setGrnData((prev) => {
      const productList = grnItems.map((item) => ({ ...item }));

      const { updatedProducts, billings, taxes } = calculateGrnTotals({
        products: productList,
        billings: prev.billings,
        addedCharges,
        otherchargevalue,
      });

      return {
        ...prev,
        products: updatedProducts,
        billings,
        taxes,
        addedCharges,
        otherchargevalue,
      };
    });
  }, [grnItems, addedCharges, otherchargevalue]);
  // new

  const calculateTaxTotalsByCode = (items) => {
    const taxTotals = {};

    items.forEach((item) => {
      const taxCode = item.taxcode?.toString() || GRN_CREATE_LABELS.TAX_CODE_UNKNOWN;
      const taxValue = Number(item.taxvalue) || 0;

      if (!taxTotals[taxCode]) {
        taxTotals[taxCode] = 0;
      }
      taxTotals[taxCode] += taxValue;
    });

    return taxTotals;
  };
  // Consolidated tax calculation useEffect - calculates both taxValues and totalTax
  // in a single effect to avoid circular dependencies
  useEffect(() => {
    if (grnItems.length > 0) {
      const totals = calculateTaxTotalsByCode(grnItems);
      setTaxValues(totals);

      // Calculate total tax from the totals we just computed
      const newTotalTax = Object.values(totals).reduce<number>(
        (acc, val) => acc + (Number(val) || 0),
        0
      );
      setTotalTax(newTotalTax);
    } else {
      setTaxValues({});
      setTotalTax(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grnItems]); // Only depend on grnItems - setters are stable

  // Extract primitive values for dependency tracking (prevents object reference changes)
  const billLevelDiscountPercent = grnData.billings?.billLevelDiscountPercent ?? 0;
  const billLevelTaxPercent = grnData.billings?.billLevelTaxPercent ?? 0;
  const addedChargesLength = Array.isArray(addedCharges) ? addedCharges.length : 0;
  const addedChargesHash = useMemo(() => {
    // Create stable hash of addedCharges to detect actual changes
    return JSON.stringify(addedCharges?.map(c => ({
      chargecode: c.chargecode,
      chargevalue: c.chargevalue || c.chaegerate
    })) || []);
  }, [addedCharges]);

  // Track if we have any added items (for billing calculations)
  const hasAddedItemsRef = useRef<boolean>(false);

  // Update the ref when grnItems change, but don't trigger re-processing
  useEffect(() => {
    hasAddedItemsRef.current = grnItems.some((item) => item.isAdded === true);
  }, [grnItems]);

  // Sync calculated values (grossvalue → value field) after process response
  // Use ref to track last processed response to prevent infinite loops
  const lastSyncedResponseRef = useRef<string | null>(null);
  
  useEffect(() => {
    if (!processResponse) {
      return;
    }

    // Create stable hash to prevent re-processing same response
    const responseHash = JSON.stringify(processResponse);
    if (lastSyncedResponseRef.current === responseHash) {
      return; // Already processed this response
    }

    const responseData = Array.isArray(processResponse) ? processResponse[0] : processResponse;
    const calculatedProducts = responseData?.dtCalProducts;

    if (!calculatedProducts || calculatedProducts.length === 0) {
      lastSyncedResponseRef.current = responseHash;
      return;
    }

    // Mark as processed before updating state to prevent re-trigger
    lastSyncedResponseRef.current = responseHash;

    setGrnItems((prevItems) =>
      prevItems.map((item) => {
        const calculatedProduct = calculatedProducts.find(
          (p: AnyForNow) => String(p.supproductcode) === String(item.supproductcode)
        );

        if (!calculatedProduct) {
          return item;
        }

        const calculatedGross = Number(calculatedProduct.grossvalue) || 0;
        const calculatedTax = Number(calculatedProduct.taxvalue);
        const hasCalculatedTax = !Number.isNaN(calculatedTax);

        // Only update if values actually changed to prevent unnecessary re-renders
        if (
          item.grossvalue === calculatedGross &&
          (!hasCalculatedTax || item.taxvalue === calculatedTax)
        ) {
          return item;
        }

        return {
          ...item,
          grossvalue: calculatedGross,
          itemvalue: calculatedGross, // displayed in the Value field
          taxvalue: hasCalculatedTax ? calculatedTax : item.taxvalue,
        };
      })
    );
  }, [processResponse, setGrnItems]);

  // Reactive useEffect: Only trigger API when user changes billing values
  // Uses primitive values and stable hash to prevent infinite loops
  useEffect(() => {
    // Skip auto-processing if a manual operation (Save/Hold button) is in progress
    if (isManualOperation.current) {
      console.log("Skipping auto-process during manual operation");
      return;
    }

    // Skip if no added items
    if (!hasAddedItemsRef.current) {
      return;
    }

    // Only process when billing values actually change (not on initial render)
    console.log("Billing values changed - scheduling ProcessGrn");
    scheduleProcessGrn();

    // Cleanup: clear timeout on unmount or dependency change
    return () => {
      if (processTimeoutRef.current) {
        clearTimeout(processTimeoutRef.current);
        processTimeoutRef.current = null;
      }
    };
  }, [
    // Use primitive values and stable hash instead of objects/functions
    billLevelDiscountPercent,
    billLevelTaxPercent,
    addedChargesHash,
    // Removed scheduleProcessGrn - function is stable with empty deps
  ]);

  useEffect(() => {
    if (grnPaySummary) {
      setGrnData((prev) => ({
        ...prev,
        billings: {
          ...prev.billings,
          totalGross: Number(grnPaySummary.totgross) || 0,
          discountAmount: Number(grnPaySummary.totproductdiscount) || 0,
          vatAmount: Number(grnPaySummary.tottax) || 0,
          netValue: Number(grnPaySummary.totnettgross) || 0,
          finalInvoiceValue: Number(grnPaySummary.totinvoice) || 0,
          penaltyCharges: Number(grnPaySummary.totpenalty) || 0,
          billLevelDiscountPercent: Number(grnPaySummary.bulkdiscountrate) || 0,
          bulkDiscountPercent: Number(grnPaySummary.bulkdiscountrate) || 0,
        },
      }));

      setTotalGross(Number(grnPaySummary.totgross) || 0);
    }
  }, [grnPaySummary]);

  // Set billLevelTaxPercent from payTax when editing (if bill-level tax exists)
  useEffect(() => {
    if (
      payTax &&
      payTax.length > 0 &&
      payTax[0]?.taxcode === TAX_CODE.BILL_LEVEL
    ) {
      const taxRate = Number(payTax[0]?.ptaxrate || payTax[0]?.taxrate) || 0;
      if (taxRate > 0) {
        setGrnData((prev) => ({
          ...prev,
          billings: {
            ...prev.billings,
            billLevelTaxPercent: taxRate,
          },
        }));
      }
    }
  }, [payTax]);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <GrnSupplierSearch
          supplierOptions={supplierOptions}
          selectedSupplier={stableSelectedSupplier}
          setSelectedSupplier={setSelectedSupplier}
          searchBy={searchBy}
          setSearchBy={setSearchBy}
          onAddNewSupplier={handleAddNewSupplier}
          rightSidebarOpen={rightSidebarOpen}
          setRightSidebarOpen={setRightSidebarOpen}
          toggleFilter={toggleFilter}
          toggleRightSidebar={toggleRightSidebar}
        />
      </Box>
      <Collapse
        in={showFilter}
        timeout="auto"
        sx={styles.advance_search_container}
        unmountOnExit
      >
        <Box sx={styles.filter_container}>
          <Typography variant="subtitle_s" color="text.secondary">
            {GRN_CREATE_LABELS.FILTER_BY_DATE_RANGE}
          </Typography>
          <Grid container spacing={2} my={1}>
            <Grid size={{ xs: 3 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={GRN_CREATE_LABELS.DATE_FROM}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={GRN_CREATE_LABELS.DATE_TO}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            mr: rightSidebarOpen ? EDIT_GRN_UI.RIGHT_SIDEBAR_WIDTH : 0,
            width: {
              sm: `calc(100% - ${rightSidebarOpen ? EDIT_GRN_UI.RIGHT_SIDEBAR_WIDTH_PX : 0}px)`, // width shrinks by sidebar width when open
            },
          }}
        >
          <ViewDataGrid
            columns={advanceSearchData.columns}
            // rows={rows}
            rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
            menuItems={menuItems}
            // tabletitle={sampleData.name}
            // displayActions={false}
            gridid={EDIT_GRN_UI.GRID_ID}
            {...({ sx: styles.view_data_grid_page } as any)}
          />
        </Box>

        <PurchaseOrderItemsPopUp open={openDialog} handleClose={handleClose} />
      </Collapse>

      <Divider />

      <Box
        sx={{
          mr: rightSidebarOpen ? "0" : 0,
          width: "100%",
        }}
      >
        <GrnDetails
          {...grnDetailsForm}
          errors={grnDetailsErrors}
          setErrors={setGrnDetailsErrors}
          grnHeader={grnHeaderSupplier}
          isEditMode={isEditMode}
        />
      </Box>

      <Box sx={styles.edgrn_save_btn_box}>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          sx={{ ...styles.btn_primary }}
          onClick={handleUpdateGrnBasic}
        >
          {BUTTON_LABELS.SAVE}
        </Button>
      </Box>

      <Divider />
      {/* Grn Items */}
      <Box py={2} pb={2} sx={styles.grn_search_container}>
        <GrnItemsTable
          setTabValue={setTabValue}
          openSidebarToBillingInfo={openSidebarToBillingInfo}
          {...grnItemsTable}
          onGrossChange={handleTotalGrossChange}
          grnItems={grnItemsTable.grnItems}
          setGrnItems={setGrnItems}
          updateRowField={grnItemsTable.updateRowField}
          addItemToTable={grnItemsTable.addItemToTable}
          removeItemFromTable={grnItemsTable.removeItemFromTable}
          handleItemChange={grnItemsTable.handleItemChange}
          supplierItems={supplierItems}
          setSupplierItems={setSupplierItems}
          expanded={expanded}
          setExpanded={setExpanded}
          popupType={popupType}
          setPopupType={setPopupType}
          fileName={fileName}
          setFileName={setFileName}
          documentType={documentType}
          setDocumentType={setDocumentType}
          reasonForReje={reasonForReje}
          setReasonForReje={setReasonForReje}
          errors={errors}
          setErrors={setErrors}
          toggleExpand={toggleExpand}
          inputValue={inputValue}
          setInputValue={setInputValue}
          handleAddNewItem={handleAddNewItem}
          toggleRejectItems={toggleRejectItems}
          toggleFocItems={toggleFocItems}
          showFocItems={showFocItems}
          showRejectItems={showRejectItems}
          showItemAttachments={showItemAttachments}
          toggleItemAttachments={toggleItemAttachments}
          rejectItems={rejectItems}
          setRejectItems={setRejectItems}
          handleClearRejectItems={handleClearRejectItems as any}
          handleClearAttachments={handleClearAttachments as any}
          handleClearFocItems={handleClearFocItems as any}
          grnReturns={grnReturns}
          grnTaxTypes={grnTaxTypes}
          grnData={grnData}
          setGrnData={setGrnData}
          onAddItem={scheduleProcessGrn}
          payTax={payTax}
        />
      </Box>
      <Box sx={styles.edgrn_save_btn_box}>
        {/* mt1 prev style */}
        <Button
          variant="contained"
          color="primary"
          size="medium"
          sx={{ ...styles.btn_primary }}
          onClick={handleUpdateProductData}
        >
          {BUTTON_LABELS.SAVE}
        </Button>
      </Box>

      <Box sx={{ width: EDIT_GRN_UI.ATTACHMENTS_WIDTH }}>
        {" "}
        <GrnAttachments
          attachments={grnAttachments}
          setAttachments={setAttachments}
          grncode={grncode}
          grndoccode={grndoccode}
          refreshGrnData={() => fetchGrnData(grncode, trsts)}
        />{" "}
      </Box>
      <Box
        sx={{
          ...styles.edgrn_save_btn_box,
          width: EDIT_GRN_UI.ATTACHMENTS_WIDTH,
          mb: 15,
        }}
      >
        {/* mt1 prev style */}
        <Button
          variant="contained"
          color="primary"
          size="medium"
          sx={{ ...styles.btn_primary }}
          onClick={handleUpdateDocsData}
        >
          {BUTTON_LABELS.SAVE}
        </Button>
      </Box>
      <Box
        ref={rightSidebarRef}
        sx={{
          ...styles.grn_right_sidebar_box,
          right: rightSidebarOpen ? 0 : EDIT_GRN_UI.RIGHT_SIDEBAR_HIDDEN_OFFSET,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0 }}>
          <IconButton
            onClick={toggleRightSidebar}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab label={GRN_SECTIONS.SUPPLIER_DETAILS} />
            <Tab label={GRN_SECTIONS.BILLING_INFO} />
          </Tabs>

          <TabPanel value={tabValue} index={EDIT_GRN_TAB_INDEX.SUPPLIER_DETAILS}>
            <GrnSupplierDetails supplier={selectedSupplier} hideTitle />
          </TabPanel>

          <TabPanel value={tabValue} index={EDIT_GRN_TAB_INDEX.BILLING_INFO}>
            <GrnBillingInfo
              setBillLevelDiscountPercent={setBillLevelDiscountPercent}
              applyBillLevelDiscountToProducts={
                applyBillLevelDiscountToProducts
              }
              disableBillLevelTax={grnItemsTable.disableBillLevelTax}
              setTaxValues={setTaxValues}
              grnData={grnData}
              setBillLevelTaxAmount={setBillLevelTaxAmount}
              applyBillLevelTaxToProducts={applyBillLevelTaxToProducts}
              grncharges={grncharges}
              setGrnCharges={setGrnCharges}
              addedCharges={addedCharges}
              otherchargevalue={otherchargevalue}
              setAddedCharges={setAddedCharges}
              origin={GRN_VIEW_DETAIL.ORIGIN_EDIT}
              processResponse={processResponse}
              setIsBillingSaved={setIsBillingSaved}
              payTax={payTax}
            />
          </TabPanel>
        </Box>
      </Box>

      <Divider />

      <Grid
        container
        spacing={2}
        sx={{
          ...styles.grn_action_container,
        }}
      >
        <Grid
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{ ...styles.btn_secondary }}
            onClick={handleCancelClick}
          >
            {BUTTON_LABELS.CANCEL}
          </Button>

          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...styles.btn_primary }}
            onClick={async () => {
              // Prevent infinite loop from useEffect auto-processing
              isManualOperation.current = true;

              try {
                const addedItems = grnItems.filter((item) => item.isAdded);

                // Validate fields first
                const validationErrors = validateFields();
                if (Object.keys(validationErrors).length > 0) {
                  console.log("Validation errors:", validationErrors);
                  setGrnDetailsErrors(validationErrors); // Set errors to state for UI display
                  enqueueMessages(Object.values(validationErrors));
                  showAlert(GRN_ERROR_MESSAGES.ALL_FIELDS_REQUIRED, "error");
                  isManualOperation.current = false;
                  return;
                }

                // Clear errors if validation passes
                setGrnDetailsErrors({});

                // 1. Process GRN to get calculations first
                console.log("Hold button: Processing GRN calculations...");
                const response = await handleProcessGrn();
                if (!response) {
                  console.error("Hold button: ProcessGrn failed");
                  isManualOperation.current = false;
                  return;
                }
                console.log("Hold button: ProcessGrn response received:", response);

                // 2. SAVE discounts, taxes, and all product data to database
                // try {
                //   console.log("Hold button: Saving product data to database...");
                //   await new Promise((resolve, reject) => {
                //     UpdateGrnProductData({
                //       grnItems: grnItemsTable.grnItems.filter((item) => item.isAdded === true),
                //       attachments,
                //       USERNAME,
                //       grncode,
                //       grnData,
                //       STAFFMAPLOCODE,
                //       COMPCODE,
                //       sts: "4",
                //       trsts: "4",
                //       charges: otherchargevalue,
                //       addedCharges,
                //       payTax,
                //       calSummary: response, // Use fresh calculation response
                //       onSuccess: (saveResponse) => {
                //         console.log("Hold button: Product data saved successfully:", saveResponse);
                //         console.log("dd",UpdateGrnProductData)
                //         showAlert(GRN_SUCCESS_MESSAGES.UPDATE_SUCCESS, "success");
                //         resolve(saveResponse);
                //       },
                //       onError: (error) => {
                //         console.error("Hold button: Failed to save product data:", error);
                //         showAlert(GRN_FAILURE_MESSAGES.UPDATE_FAILED, "error");
                //         reject(error);
                //       },
                //     });
                //   });
                // } catch (error) {
                //   console.error("Hold button: Save failed, aborting hold operation:", error);
                //   isManualOperation.current = false;
                //   return; // Don't proceed if save failed
                // }

                // 3. Navigate to view with hold status
                console.log("Hold button: Navigating to view...");
                goNextToView(
                  isApprovalWorkflowEnabled
                    ? APPROVAL_WORKFLOW.ENABLED.SAVE_STATUS
                    : APPROVAL_WORKFLOW.DISABLED.SAVE_STATUS,
                  addedItems,
                  response
                );

                // Reset flag after successful navigation
                isManualOperation.current = false;
              } catch (error) {
                console.error("Hold button: Unexpected error:", error);
                isManualOperation.current = false;
              }
            }}
          >
            {BUTTON_LABELS.HOLD}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...styles.btn_primary }}
            onClick={async () => {
              const addedItems = grnItems.filter((item) => item.isAdded);

           
              const response = await handleProcessGrn();
              if (!response) return;

              goNextToView(
                isApprovalWorkflowEnabled
                  ? APPROVAL_WORKFLOW.ENABLED.SUBMIT_STATUS
                  : APPROVAL_WORKFLOW.DISABLED.SUBMIT_STATUS,
                addedItems,
                response // 
              );
            }}
          >
            {BUTTON_LABELS.NEXT}
          </Button>
        </Grid>
      </Grid>
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={handleAlertClose}
      />
      <PopUp
        open={confirmCancelOpen}
        handleClose={handleCancelClose}
        title={GRN_CREATE_LABELS.CONFIRM_CANCEL_TITLE}
        content={<Typography>{GRN_CONFIRM_MESSAGES.LEAVE_UNSAVED}</Typography>}
        actions={
          <>
            <Button onClick={handleCancelClose} color="primary">
              {BUTTON_LABELS.NO}
            </Button>
            <Button 
              onClick={handleConfirmCancel} 
              variant="contained"
              color="primary" 
              autoFocus
              sx={{ 
                backgroundColor: "#1677FF",
                "&:hover": {
                  backgroundColor: "#1677FF",
                  opacity: 0.9
                }
              }}
            >
              {BUTTON_LABELS.YES}
            </Button>
          </>
        }
      />
    </>
  );
};

export default EditGrn;
